import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { roundNumbers } from "helpers/roundNumbers";
import React, { useEffect, useState } from "react";

export const TableBlock = ({ data }) => {
  const [headers, setHeaders] = useState([]);

  useEffect(() => {
    if (!!Object.keys(data)?.length) {
      const elements = Object.keys(data);
      setHeaders(["Variable", ...Object.keys(data[elements[0]])]);
    }
  }, [data]);

  return (
    <>
      {!!headers.length && (
        <TableContainer
          component={Paper}
          sx={{
            boxShadow: "none",
            boxSizing: "border-box",
            maxHeight: "400px",
            border: "1px solid rgb(233, 236, 239)",
            borderRadius: "6px",
          }}
        >
          <Table stickyHeader sx={{ width: "100%" }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headers.map((header) => (
                  <TableCell
                    key={`header:${header}`}
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 600,
                      color: "#101828",
                      minWidth: "150px",
                      lineHeight: "19px",
                      background: "linear-gradient(0deg, #FAFBFB, #FAFBFB)",
                      borderColor: "#F2F4F7",
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              sx={{ "& .MuiTableCell-root": { borderColor: "#F2F4F7", fontWeight: 400, color: "#101828" } }}
            >
              {Object.keys(data)?.map((row, index) => (
                <TableRow hover key={index} sx={{ backgroundColor: index % 2 !== 0 ? "#F9FAFB" : "inherit" }}>
                  {headers.map((header) => (
                    <TableCell key={header + index} align="left">
                      <Stack>{header === "Variable" ? row : roundNumbers(data[row]?.[header])}</Stack>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};
